import { t } from '@lingui/macro';
import { RocketLaunch } from '@mui/icons-material';
import { Box, Container, Divider, Stack } from '@mui/material';
import { createApiClient } from '@prismo-io/core';
import {
  MarkdownRenderer,
  PageHeader,
  SectionTitle,
} from '@prismo-io/design-system';
import { SupabaseImage } from '@prismo-io/utils/client/supabase-image';
import { notFound } from 'next/navigation';
import { GetIntegrationAction } from '../api/get-integration.action';
import { GetToolByUrlAction } from '../api/get-tool-by-url.action';
import { ResultSwitcher } from './result-switcher';
import { SyncActionBtn } from './sync-btn';

type Props = {
  userUrl: string;
  toolUrl: string;
};

export const TsidResult = async (props: Props) => {
  const { userUrl, toolUrl } = props;

  const client = createApiClient();

  const { data: user } = await client
    .from('users')
    .select('id')
    .eq('url', userUrl)
    .maybeSingle();

  if (!user) {
    return notFound();
  }

  const resTool = await GetToolByUrlAction({ toolUrl });

  if (!resTool?.data) {
    return notFound();
  }

  const res = await GetIntegrationAction({
    toolId: resTool?.data?.id,
    userId: user.id,
  });

  if (!res?.data) {
    return notFound();
  }

  const { data } = res;

  const { isMe, hasCurrent, tool, action, relation } = data;

  if (!isMe && !hasCurrent) {
    return notFound();
  }

  const withDescription = !!tool.description && tool.description?.trim() !== '';

  return (
    <Stack width="100%" direction="column" paddingBottom={2}>
      <PageHeader
        pageComponent={
          <Box component="div" position="relative" width="3rem" height="3rem">
            <SupabaseImage
              src={tool.logo}
              alt={tool.name}
              style={{ objectFit: 'contain', objectPosition: 'center' }}
              fill
              bucket="tsid"
              replaceOnError={
                <RocketLaunch
                  sx={{ width: '100%', height: '100%' }}
                  color="primary"
                />
              }
            />
          </Box>
        }
        pageTitleRender={tool.name}
      />
      <Container
        maxWidth="lg"
        sx={{ paddingX: { none: '0.5rem', sx: '1rem', md: '1.5rem' } }}
      >
        <Stack direction="column" gap={4} component="section">
          {withDescription ? (
            <>
              <SectionTitle
                title={t`Description de l'outil`}
                id={`${tool.id}-description`}
                actionBtn={isMe ? <SyncActionBtn {...data} /> : undefined}
              />
              <MarkdownRenderer>{tool.description}</MarkdownRenderer>
              <Divider />
            </>
          ) : isMe ? (
            <Stack direction="row" justifyContent="flex-end">
              <SyncActionBtn {...data} />
            </Stack>
          ) : null}

          <ResultSwitcher
            kind={action.kind}
            userId={user.id}
            toolId={tool.id}
            isMe={isMe}
          />

          {/* <UploadFileResult userId={user.id} toolId={tool.id} isMe={isMe} /> */}
        </Stack>
      </Container>
    </Stack>
  );
};
